/**
 * App-wide measurement units, resolved per quantity (length, speed) so the two
 * can differ. Sourced from the SafeCurves metadata summary table's
 * `distance_units` / `speed_units` fields (e.g. 'feet', 'mph'); until that read
 * resolves each quantity defaults to DEFAULT_SYSTEM. Drives both the display
 * units of convertible fields (`_m`/`_ft`) and the unit labels applied to
 * jurisdictional (`_x`) fields.
 */
import { systemFromDbUnit, type Quantity, type UnitSystem } from '#lib/intlUnits.js';

const DEFAULT_SYSTEM: UnitSystem = 'imperial';

function createUnitSystemStore() {
	const systems = $state<Record<Quantity, UnitSystem>>({
		length: DEFAULT_SYSTEM,
		bigLength: DEFAULT_SYSTEM,
		speed: DEFAULT_SYSTEM
	});
	return {
		systemFor(quantity: Quantity): UnitSystem {
			return systems[quantity];
		},
		/** Applies the metadata table's DB unit strings; unrecognised values leave the default in place. */
		setFromMetadata(row: {
			distance_units?: string | number | null;
			speed_units?: string | number | null;
		}) {
			const length =
				row.distance_units != null && systemFromDbUnit('length', String(row.distance_units));
			const speed = row.speed_units != null && systemFromDbUnit('speed', String(row.speed_units));
			// The metadata has no separate big-length unit, so km/mi follows the distance unit.
			if (length) systems.length = systems.bigLength = length;
			if (speed) systems.speed = speed;
		}
	};
}

export const unitSystemStore = createUnitSystemStore();
